import { LiteTradePortfolioEmptyStyled } from "./styled/LiteTradePortfolioEmptyStyled.js";
import { BinIcon, IconAsset } from "../../../../components/icon/Icon.jsx";
import { Button } from "react-bootstrap";
import {
    MOBILE_SLIDER_PAGES_IDS
} from "../../../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants.js";
import { useCallback, useMemo } from "react";
import { openMobileSliderPageAction } from "../../../../mobileAppCore/mobileAppActions.js";
import { connect } from "react-redux";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { createStructuredSelector } from "reselect";
import { getLiteTradeAssets } from "../../liteTradeSelectors.js";
import _ from "lodash";
import Asset from "../../../Asset/Asset.js";

const recommendedSymbols = [
    'EURUSD',
    'GBPUSD',
    'XAUUSD',
    'BTCUSD',
    'ETHUSD',
];

function LiteTradePortfolioEmpty(props) {
    const {
        assets,
        openMobileSliderPage,
    } = props;
    const { getLangPath } = useLangContext();

    const asset = useMemo(() => {
        if (assets) {
            const findAsset = () => {
                for (let i = 0; i < recommendedSymbols.length; i++) {
                    const symbol = recommendedSymbols[i];
                    const assetInfo = _.find(assets, { symbol });
                    if (assetInfo) {
                        const assetInstance = new Asset(assetInfo);
                        if (assetInstance.isTradingNow()) return assetInstance;
                    }
                }
            }
            return findAsset();
        }
    }, [assets]);

    const clickHandler = useCallback((e) => {
        e.preventDefault();
        openMobileSliderPage({
            name: MOBILE_SLIDER_PAGES_IDS.ASSET,
            symbol: asset.symbol,
        });
    }, [asset?.symbol, openMobileSliderPage]);

    if (!asset) {
        return null;
    }

    return <LiteTradePortfolioEmptyStyled onClick={clickHandler}>
        <div className="col-left">
            <IconAsset symbol={asset.symbol} size={32}/>
        </div>
        <div className="col-center">
            <div className="title">{asset.info?.description}</div>
            <div className="sub-title">{getLangPath('lite_version.home.recommended')}</div>
        </div>
        <div className="col-right">
            <Button variant={'outline-primary'}>
                <BinIcon name={'IcForward'} size={24}/>
            </Button>
        </div>
    </LiteTradePortfolioEmptyStyled>
}

const mapStateToProps = createStructuredSelector({
    assets: getLiteTradeAssets,
});

const mapDispatchToProps = (dispatch) => ({
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiteTradePortfolioEmpty);
